import { base1 } from './base-1';
import { base2 } from './base-2';
import { bpmn } from './bpmn';
// import {dmn} from './dmn';
import { propsPanel } from './props-panel';

type Keys =
    | keyof typeof base1
    | keyof typeof base2
    | keyof typeof bpmn
    // | keyof typeof dmn
    | keyof typeof propsPanel;

type Translations = Record<Keys, string> & Record<string, string>;

const allTranslations: Translations = {
    ...base1,
    ...base2,
    ...bpmn,
    // ...dmn,
    ...propsPanel,
    Action: 'Aktion',
    'Break permission inheritance': 'Berechtigung unterbrechen',
    'Choose from': 'Wählen Sie aus',
    'Choices are loading': 'Auswahl wird geladen',
    Create: 'Erstellen',
    'Create User Task': 'Benutzeraufgabe erstellen',
    'Determines the starting order when creating items.':
        'Bestimmt die Startreihenfolge bei der Item-Erstellung.',
    'Determines when the process should be started.': 'Bestimmt, wann der Prozess gestartet wird.',
    Editors: 'Editoren',
    'Editors from fields': 'Editoren aus Feldern',
    'Editorial group': 'Editorengruppe',
    Email: 'E-Mail',
    'Email dispatch': 'E-Mail-Versand',
    Entering: 'Eintritt',
    ExecuteOn: 'Ausführen bei',
    'Target Ids': 'Variable für Id(s) oder das Feld des Ziels',
    Field: 'Feld',
    Filter: 'Filter',
    Yes: 'Ja',
    'JSON format': 'JSON-Format',
    'Including version history': 'Inklusive Versionshistorie',
    Interrupt: 'Unterbrechen',
    Leaving: 'Austritt',
    'Loading...': 'Laden...',
    'List fields': 'Listenfelder',
    'List filter': 'Listenfilter ($filter)',
    'List select': 'Filter Feldauswahl ($select)',
    'List expand': 'Filter Felderweiterung ($expand)',
    'List field': 'Auszulesende Listenspalte',
    'List item': 'Listeneintrag',
    'Maintain existing permissions': 'Bestehende Rechte behalten',
    No: 'Nein',
    'No matches found': 'Es wurden keine Einträge gefunden',
    'No selection available': 'Keine Auswahl vorhanden',
    'Number of versions': 'Anzahl Versionen',
    'Only positive numbers without decimal places are allowed':
        'Nur positive Zahlen ohne Nachkommastellen sind erlaubt',
    Permissions: 'Berechtigungen',
    'Press Ctrl to open the selection menu': 'Drücken Sie Strg, um das Auswahlmenü zu öffnen',
    Readers: 'Leser',
    'Readers from fields': 'Leser aus Feldern',
    'Reader group': 'Lesergruppe',
    Recipient: 'Empfänger',
    'Reply to': 'Antwort an',
    Reset: 'Zurücksetzen',
    'Select {item}': 'Wählen Sie aus: {item}',
    'Selected {items}': 'Ausgewählte {items}',
    // 'Select an entry': 'Wählen Sie einen Eintrag aus',
    // 'Select a site': 'Wählen Sie eine Seite aus',
    // 'Select a list': 'Wählen Sie eine Liste aus',
    // 'Select a type': 'Wählen Sie einen Typ aus',
    'Send on': 'Versenden bei',
    Site: 'Seite',
    'Source list': 'Quellliste',
    'Process list': 'Prozess',
    SubSite: 'Sub Site',
    Subject: 'Betreff',
    'Target list': 'Zielliste',
    'Start when': 'Starten wenn',
    'Start priority': 'Start-Priorität',
    'This maps to the process definition key.':
        'Die Camunda Prozess-ID wird vom System vergeben und ist unveränderlich, um Versionierung sicherzustellen.',
    Unaltered: 'Unverändert',
    'User task': 'Benutzeraufgabe',
    'User Task': 'Benutzeraufgabe',
    '<empty>': '<leer>',
    'spListEntry-find': 'Ermitteln',
    'spListEntry-create': 'Erstellen',
    'spListEntry-update': 'Aktualisieren',
    'spListEntry-copy': 'Kopieren',
    'spListEntry-move': 'Verschieben',
    'spListEntry-delete': 'Löschen',
    'spListEntry-startProcess': 'Prozess starten',
    'spListEntry-current': 'Aktuelles Element',
    'spListEntry-subsite': 'Liste auf Sub Site',
    'spListEntry-current-list': 'Aktuelle Liste',
    'spListEntry-list': 'Liste auf aktueller Seite',
    'spExecuteOn-entering': 'Task-Eintritt',
    'spExecuteOn-leaving': 'Task-Austritt',
    'SharePoint actions': 'SharePoint Aktionen',
    'SharePoint list': 'SharePoint Liste',
    'Please first select a site in the process in the group "SharePoint list".':
        'Bitte wählen Sie zunächst eine Seite im Prozess in der Gruppe "SharePoint Liste" aus.',
    // add/override trunslations
    Variables: 'Variablen',
};

export const translations = allTranslations as Record<string, string>;
